export default __webpack_public_path__ + "static/media/Exclude.ad7d75db.svg";